module.exports = __webpack_public_path__ + "static/AngelaHe4-7e1f979864765ef5c43c9e1dcbc44863.webp";